// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2497ed","colorSecondary":"#eaf5fe","SignOut":"SignOut_SignOut__cqqKN","img":"SignOut_img__3SLnu"};